<script>
  import AOS from 'aos';
  import 'aos/dist/aos.css';

  import { page } from '@inertiajs/svelte';

  import AdminBar from '../shared/AdminBar.svelte';
  import Header from '../shared/header/Index.svelte';
  import DefaultFooter from '../shared/footer/Default.svelte';
  import ContactsFooter from '../shared/footer/Contacts.svelte';

  export let admin_bar;
  export let title;
  export let site_name;
  export let footer;

  $: pageTitle = `${title} - ${site_name}`;

  $: footerComponent =
    $page.component === 'Contacts/Index' ? ContactsFooter : DefaultFooter;

  AOS.init({
    once: true,
    easing: 'ease-in-out',
  });
</script>

<svelte:head>
  <title>{pageTitle}</title>
</svelte:head>

{#if admin_bar.show}
  <AdminBar admin={admin_bar} />
{/if}

<Header />

<main>
  <slot />
</main>

<svelte:component this={footerComponent} {footer} />
